import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import RequestTableFormFieldTable from "components/ProjectSpecificComponents/Elements/Tables/organisms/RequestTableFormFieldTable"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { observer } from "mobx-react"
import React from "react"
import ModalWithTwoParts from "./ModalWithTwoParts"

interface Props {
	onClose?: TOnClick<HTMLButtonElement | HTMLElement>
}

const RequestTableModal = observer(({ onClose = () => {} }: Props) => {
	const formStore = useFormStore()

	return (
		<ModalWithTwoParts onClose={onClose}>
			<HyperDiv padding="2rem">
				{formStore.selectedFormsConfig == null ||
				formStore.selectedFormsConfig.requestTable.length == 0 ? (
					<div>Add fields in order to preview</div>
				) : (
					<RequestTableFormFieldTable config={formStore.selectedFormsConfig.requestTable} />
				)}
			</HyperDiv>
		</ModalWithTwoParts>
	)
})

export default RequestTableModal
